import { MAX_TEXT_PREVIEW_BYTES, sanitizeFileUrl } from "./filePreview.js";
import { fetchProtectedPreviewUrl } from "./exportPdfPreview.js";

/**
 * Lädt geschützte /api/… und /export/…-Dateien mit Session-Cookie.
 * @deprecated Alias – bitte fetchProtectedPreviewUrl verwenden.
 */
export async function fetchAuthenticatedPreviewUrl(url = "") {
  return fetchProtectedPreviewUrl(url);
}

/**
 * Lädt Textinhalte für die Vorschau (Plaintext, keine HTML-Ausgabe).
 * @returns {Promise<{ ok: true, text: string, truncated?: boolean } | { ok: false, error: string, maxBytes?: number }>}
 */
export async function fetchAuthenticatedPreviewText(
  url = "",
  { maxBytes = MAX_TEXT_PREVIEW_BYTES, signal = undefined } = {},
) {
  const safe = sanitizeFileUrl(url);
  if (!safe) {
    return { ok: false, error: "INVALID_URL" };
  }

  const res = await fetch(safe, {
    method: "GET",
    credentials: "include",
    signal,
  });
  if (!res.ok) {
    throw new Error(`PREVIEW_FETCH_${res.status}`);
  }

  const contentLength = Number(res.headers.get("content-length") || 0);
  if (contentLength > maxBytes) {
    return { ok: false, error: "TOO_LARGE", maxBytes };
  }

  const blob = await res.blob();
  if (blob.size > maxBytes) {
    return { ok: false, error: "TOO_LARGE", maxBytes };
  }

  const text = await blob.text();
  if (text.length > maxBytes) {
    return {
      ok: true,
      text: text.slice(0, maxBytes),
      truncated: true,
    };
  }

  return { ok: true, text };
}

export function revokeAuthenticatedPreviewUrl(url = "") {
  if (String(url || "").startsWith("blob:")) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      /* ignore */
    }
  }
}
